import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/core/navbar";
import ScrollToTop from "./components/core/ScrollToTop";
import PageViewTracker from "./components/core/PageViewTracker";

import { hasCookieConsent } from "./consent/cookieConsent";

import Home from "./components/pages/main/index";
import ServicePage from "./components/pages/services/index";
import { SERVICE_SLUGS } from "./components/pages/services/servicesContent";

import Faq from "./components/pages/resources/faq/index";

import Contact from "./components/pages/contact/index";
import ThankYou07 from "./components/pages/contact/ThankYou07";

import PrivacyPolicy from "./components/pages/legal/privacy/index";
import TermsConditions from "./components/pages/legal/terms/index";

import Footer from "./components/core/footer";
import CookieConsent from "./components/core/CookieConsent";

function App() {
  const [analyticsAllowed, setAnalyticsAllowed] = useState(() =>
    hasCookieConsent()
  );

  return (
    <BrowserRouter>
      <PageViewTracker analyticsAllowed={analyticsAllowed} />
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/services"
          element={<Navigate replace to={`/services/${SERVICE_SLUGS[0]}`} />}
        />
        <Route
          path="/services/deep-web-radar"
          element={<Navigate replace to="/services/hidden-leak-detection" />}
        />
        <Route
          path="/services/encrypted-client-architecture"
          element={
            <Navigate replace to="/services/secure-creator-infrastructure" />
          }
        />
        <Route
          path="/services/elite-network-system"
          element={<Navigate replace to="/services/creator-protection-circle" />}
        />
        <Route path="/services/:serviceSlug" element={<ServicePage />} />

        <Route path="/faq" element={<Faq />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/thank-you" element={<ThankYou07 />} />
      </Routes>
      <Footer />
      <CookieConsent onAccept={() => setAnalyticsAllowed(true)} />
    </BrowserRouter>
  );
}

export default App;
